import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';

const service = EventEmitterFactory();

export const PropertyCardInteractionService = () => service;
